module.exports = __webpack_public_path__ + "img/Arabi.d8230ed3.png";